// [2025.06.09] 참조값 관련 추가
// useComtrueRefs.js
import { useEffect } from 'react'
import { COMTRUEVAR } from './ocr_variables'

export const useComtrueRefs = (refs) => {
    useEffect(() => {
        // refs 객체의 모든 ref를 COMTRUEVAR에 할당
        Object.entries(refs).forEach(([key, ref]) => {
            if (ref.current) {
                COMTRUEVAR[`${key}`] = ref.current
            }
        })

        // cleanup 함수
        return () => {
            Object.keys(refs).forEach((key) => {
                COMTRUEVAR[`${key}`] = null
            })
        }
    }, [refs])
}
